import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { ModalState, IHelpPagePartner } from '@whitelabel/xcover-shared/helpers/types';
import { StyledContactFormCard } from '@whitelabel/xcover-shared/styled/StyledContactFormCard';
import PartnerHeader from '../ParterHeader';
import ContactFormInModal from '../../forms/ContactForm/ContactFormInModal';

interface IContactPurposeProps {
  toggleModalClose: () => void;
  partner?: IHelpPagePartner;
  setStep: (step: ModalState) => void;
  bookingID?: string;
}

const ContactFormCard = ({ toggleModalClose, partner, setStep, bookingID }: IContactPurposeProps): JSX.Element => {
  const returnPreviousStep = () => {
    setStep('single-policy');
  };
  const submitSuccess = () => {
    setStep('confirmation');
  };
  return (
    <StyledContactFormCard>
      <PartnerHeader
        enableReturn
        returnPreviousStep={returnPreviousStep}
        toggleModalClose={toggleModalClose}
        partner={partner}
      />
      <Card>
        <CardBody>
          <ContactFormInModal
            onSubmitSuccess={submitSuccess}
            onCancelButtonClick={toggleModalClose}
            bookingID={bookingID}
          />
        </CardBody>
      </Card>
    </StyledContactFormCard>
  );
};

export default ContactFormCard;
